import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {useEscpacePress} from '@/hooks';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {Marker} from '@/map/modules';
import {Flexbox} from '@/styled-components';
import {palette} from '@/styles/palette';
import {CursorTextContent, IContentProps} from './CursorTextContent';

interface IProps extends naver.maps.MarkerOptions {
  position: naver.maps.Coord;
  menu?: {[key: string]: string};
  onEscKeyPress?(): void;
}

export const DrawInfoCursor = ({
  map,
  position,
  menu,
  onEscKeyPress,
  ...props
}: IProps & IContentProps) => {
  useEscpacePress(onEscKeyPress);

  if (!position) {
    return null;
  }

  return (
    <Marker
      map={map}
      position={position}
      draggable={false}
      clickable={false}
      zIndex={MAP_LAYER_Z_INDEX.MAP_CURSOR}
    >
      <>
        <CursorTextContent {...props} />
        {!!menu && Object.keys(menu).length > 0 && (
          <Menu>
            {Object.entries(menu).map(([key, value]) => (
              <Item key={key}>
                <Typography variant="medium12" color={palette.gray300}>
                  {key}
                </Typography>
                <Typography variant="medium12" color={palette.white}>
                  {value}
                </Typography>
              </Item>
            ))}
          </Menu>
        )}
      </>
    </Marker>
  );
};

const Menu = styled.div`
  position: absolute;
  padding: 6px 12px;
  margin-top: 4px;
  background-color: #43494f;
  border: solid 1px #2e343b;
  border-radius: 3px;
  min-width: 128px;
`;

const Item = styled(Flexbox)`
  font-weight: 500;
  justify-content: space-between;
  margin: 0 2px;
`;
